import { PropsWithChildren } from 'react';
import styles from './style.module.scss';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	isSecondary?: boolean;
	withIcon?: boolean;
	useGlobalStyling?: boolean;
	fullwidth?: boolean;
}

export function Button(props: PropsWithChildren<IProps>) {
	const { className, children, onClick, isSecondary, withIcon, useGlobalStyling = true, fullwidth } = props;
	let classes = `${className} ${fullwidth ? styles.fullwidth : ''}`;

	if (useGlobalStyling) {
		classes += ` btn${isSecondary ? ' btn--secondary' : ' btn--primary'}${withIcon ? ' btn--copy' : ''}`;
	}

	return (
		<button className={classes} onClick={onClick}>
			{children}
		</button>
	);
}
